import { useEffect, useState } from 'react'

import {
  getActiveMerchantUuid,
  getContextMerchantUuid,
  type GroupMerchant,
  readGroupSession
} from 'lib/merchant-group'

/**
 * SC-10999: empresa do registro aberto num detalhe, só na visão multi-empresas
 * (fora dela devolve `null`).
 *
 * É a empresa em que as ações do detalhe acontecem: a empresa ativa registrada
 * pelo modal/página (ver `useActiveMerchant`) ou, sem nenhuma, a empresa de
 * contexto, que é a do token usado nesse caso.
 *
 * `recordUuid` só serve para reler quando o detalhe troca de registro.
 */
export const useDetailCompany = (recordUuid?: string | null) => {
  const [merchant, setMerchant] = useState<GroupMerchant | null>(null)

  // Lido depois da montagem: cookie e localStorage não existem no SSR, e a
  // empresa ativa é registrada no layout effect do modal, antes deste effect.
  useEffect(() => {
    const session = readGroupSession()
    if (!session) {
      setMerchant(null)
      return
    }

    const merchantUuid = getActiveMerchantUuid() || getContextMerchantUuid()
    const found = session.merchants.find(
      (item) => (item.merchant_uuid || item.uuid) === merchantUuid
    )
    setMerchant(found ?? null)
  }, [recordUuid])

  return merchant
}
